import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WizardManager, WizardMenuItemComponent } from 'src/app/shared/wizard.component';
import { SessionService } from 'src/app/services/session.service';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { Account, RoleType } from 'src/app/models/AccountModel';
import { AccountManageCompaniesComponent } from './account-manage-companies.component';
import { ManageIntegrationModel } from 'src/app/models/ManageIntegrationModel';

@Component({
  selector: 'cw-ci-settings-wizard',
  templateUrl: './settings-wizard-dialog.component.html',
  styleUrls: ['./settings-wizard-dialog.component.scss'],
})
export class SettingsWizardComponent extends WizardManager implements OnInit {
  selectedAccount: Account;
  parentAccount: Account;
  mainAccountManageIntegration: ManageIntegrationModel = {};
  startingMenuItem: string;
  showUserPages = true;
  showAccountPages: boolean;
  manageIntegrationHasUnmappedCompanies: boolean;
  disableIntegrationCheckbox: boolean;
  isSubAccount: boolean;
  @ViewChild(AccountManageCompaniesComponent) companiesScreen: AccountManageCompaniesComponent;
  @ViewChild('manageIntegration') manageIntegration: WizardMenuItemComponent;

  constructor(dialogReference: MatDialogRef<SettingsWizardComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public sessionService: SessionService, private _apiService: PlatformApiService) {
    super(dialogReference);

    this.startingMenuItem = (data && data.startingMenuItem) ? data.startingMenuItem : 'USER_START';

    if (data && data.selectedAccount) {
      this.selectedAccount = data.selectedAccount;
      this.showUserPages = false;
      this.isSubAccount = (this.selectedAccount.parentId != undefined);
      if(this.isSubAccount) {
        if(data.parentAccount) {
          this.parentAccount = data.parentAccount;
        } else {
          this.parentAccount = this.sessionService.getCurrentAccount();
        }
      }
    } else {
      this.selectedAccount = this.sessionService.getCurrentAccount();
      this.isSubAccount = false;
    }
    console.log('SettingsWizardComponent:selectedAccount', this.selectedAccount);

    this.showAccountPages = (sessionService.isAccountType('SYSTEM') && (sessionService.hasRole(RoleType.ADMIN)|| sessionService.hasRole(RoleType.SUPPORT_ADMIN)) || sessionService.hasFeature('DASHBOARD_ENABLED'));
  }

  public onEvent(event) {
    console.log('SettingsWizardComponent.onEvent', event);
    switch(event.state) {
      case 'SHOW_ACTION_BUTTONS':
        this.wizard.displayButtons = true;
        break;
      case 'HIDE_ACTION_BUTTONS':
        this.wizard.displayButtons = false;
        break;
      case 'SAVE_ACCOUNT':
        this.selectedAccount = event.item;
        this.sessionService.updateWorkingAccount(this.selectedAccount);
        event = {state:'LOAD'};
        break;
      case 'SAVE_CS_DETAILS':
        this.selectedAccount = event.item;
        this.sessionService.updateWorkingAccount(this.selectedAccount);
        break;
      case 'MANAGE_INTEGRATION_SAVED':
        this.selectedAccount.manageIntegration = event.item;
        this.sessionService.updateWorkingAccount(this.selectedAccount);
        this.mainAccountManageIntegration = this.selectedAccount.manageIntegration
        this.wizard.autoAdvance = !this.mainAccountManageIntegration.isEnabled || this.manageIntegrationHasUnmappedCompanies;
        this.wizard.updateNextButtonText();
        break;
      case 'MANAGE_INTEGRATION_ENABLED':
        this.selectedAccount.manageIntegration.isEnabled = true;
        this.sessionService.updateWorkingAccount(this.selectedAccount);
        this.mainAccountManageIntegration = this.selectedAccount.manageIntegration
        this.checkConnectwiseUnmappedSubAccounts();
        this.wizard.menuClick(this.manageIntegration);
        this.wizard.updateNextButtonText('SAVE');
        break;
      case 'MANAGE_INTEGRATION_CHECKBOX_CLICKED':
        if(this.mainAccountManageIntegration && this.mainAccountManageIntegration.isEnabled){
          this.wizard.updateNextButtonText('SAVE');
          this.wizard.autoAdvance = false;
        } else if(event.item) {
          this.wizard.updateNextButtonText('SAVE & ENABLE');
          this.wizard.autoAdvance = false;
        } else {
          this.wizard.updateNextButtonText('NEXT');
          this.wizard.autoAdvance = true;
        };
        break;
      case 'ENABLE_MANAGE_INTEGRATION_CHECKBOX':
        this.checkConnectwiseUnmappedSubAccounts();
        break;
      case 'MANAGE_INTEGRATION_COMPANIES_MAPPED':
        const complete = this.companiesScreen.getProgressPercent();
        if(complete == '100%') {
          this.wizard.updateNextButtonText('SAVE & ENABLE');
        } else {
          this.wizard.updateNextButtonText('SAVE');
        }
        break;
    };

    super.onEvent(event);
  }

  ngOnInit() {
    if(!this.isSubAccount) {
      this.checkConnectwiseUnmappedSubAccounts();
    }
    this.getMainAccountManageIntegration();
  }

  private checkConnectwiseUnmappedSubAccounts() {
    this._apiService.getManageUnmappedSubAccounts(this.selectedAccount.id).subscribe(results => {
      this.manageIntegrationHasUnmappedCompanies = this.disableIntegrationCheckbox = results.count > 0;
      this.companiesScreen.unmappedCompaniesCount = results.count;
    }, err => {
      this.manageIntegrationHasUnmappedCompanies = false;
    })
  }

  private getMainAccountManageIntegration() {
    if (this.selectedAccount.parentId) {
      this._apiService.getAccountIntegration(this.selectedAccount.parentId).subscribe(
        result=> {
          this.mainAccountManageIntegration = result;
        }
      )
    } else {
      this.mainAccountManageIntegration = this.selectedAccount.manageIntegration;
    }
  }

  getAccountNameDisplay() {
    if (this.selectedAccount) {
      let an = this.selectedAccount.id == undefined ? 'New Account' : this.selectedAccount.name;
      if (this.sessionService.isAccountType('SYSTEM') && this.selectedAccount.id != undefined) {
        an = `${an} (id: ${this.selectedAccount.id})`;
      }

      return an;
    } else {
      return '';
    }
  }

  protected onMenuClick(event) {
    if(event.menuItem.description == 'Linked Accounts' ||
      event.menuItem.description == 'Users' ||
      event.menuItem.description == 'Sub Accounts' ||
      event.menuItem.description == 'API Keys' ||
      event.menuItem.description == 'Multi-Factor Authentication') {
      this.wizard.displayButtons = false;
    } else {
      this.wizard.displayButtons = true;
    }

    super.onMenuClick(event);
  }
}